const GameRankingIcon = ({ color, width = 24, height = 24 }: { color: string; width?: number; height?: number }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.67 14H4C2.9 14 2 14.9 2 16V22H8.67V14Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3302 10H10.6602C9.56016 10 8.66016 10.9 8.66016 12V22H15.3302V12C15.3302 10.9 14.4402 10 13.3302 10Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0001 17H15.3301V22H22.0001V19C22.0001 17.9 21.1001 17 20.0001 17Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5202 2.0708L13.0502 3.1308C13.1202 3.2808 13.3102 3.42079 13.4702 3.44079L14.4302 3.6008C15.0402 3.7008 15.1902 4.15078 14.7502 4.58078L14.0002 5.33078C13.8702 5.46078 13.8002 5.70079 13.8402 5.87079L14.0502 6.7908C14.2202 7.5208 13.8302 7.80081 13.1902 7.42081L12.2902 6.89081C12.1302 6.79081 11.8602 6.79081 11.7002 6.89081L10.8002 7.42081C10.1602 7.80081 9.77023 7.5208 9.94023 6.7908L10.1502 5.87079C10.1902 5.70079 10.1202 5.45078 9.99023 5.33078L9.25023 4.59079C8.81023 4.15079 8.95023 3.71078 9.57023 3.61078L10.5302 3.4508C10.6902 3.4208 10.8802 3.28081 10.9502 3.14081L11.4802 2.08078C11.7702 1.50078 12.2302 1.5008 12.5202 2.0708Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GameRankingIcon;
